<template>
  <div>
    <HeadNav :title="headNavImg.title"
      :titleEn="headNavImg.profiles"
      :src="headNavImg.picture"></HeadNav>
    <div class="content">
      <el-row>
        <el-col
          :span="7"
          style="border-left:1px solid rgb(220,220,220);border-right:1px solid rgb(220,220,220);border-top:1px solid rgb(220,220,220);"
        >
          <ContentNav :activeIndex='this.activeId' :List="list" title="实验室服务项目" titleEn="Laboratory Services" @increase='init'></ContentNav>
        </el-col>
        <el-col :span="17" style="padding:0 50px;">
          <h3>{{headTitle}}</h3>
          <el-divider></el-divider>
          <div v-html='contentHtmlPC'
               v-loading="loading" 
          ></div>
        </el-col>
      </el-row>
    </div>
    <el-row class="MobileRow">
      <el-col
        :span="24"
        style="border-left:1px solid rgb(220,220,220);border-right:1px solid rgb(220,220,220);border-top:1px solid rgb(220,220,220);"
      >
        <ContentNav :List="mobileList" title="实验室服务项目" titleEn="Laboratory Services" @increase='init'></ContentNav>
      </el-col>
       <!-- <h3>{{headTitle}}</h3> -->
      <el-col :span='24' style='margin:20px 0'>
          <div v-html='contentHtmlMobile' class="mobileEditor"></div>
      </el-col>
    </el-row>
  </div>
</template>

<script>
import HeadNav from "../components/head.vue";
import ContentNav from "../components/content.vue";
import {getNavTitle,getProduct,getTheme} from '../api/allApiRequest.js'
export default {
  name: "LaboratoryServices",
  data() {
    return {
      title: "聚贤纳才，跃然而上",
      titleEn: "Gather talents and accept talents",
      activeName: "1",
      src: require("../assets/Services.png"),
      list: [],
      headTitle:'',
      contentHtmlPC : '',
      contentHtmlMobile:'',
      loading: false,
      headNavImg:{},
      activeId:'',
      defaultShowId:"",
      userId:"",
      mobileList:[]
    };
  },
  components: {
    HeadNav,
    ContentNav
  },
  created(){
    
  },
  mounted(){
    this.value = location.hash.split('?')[1] ? location.hash.split('?')[1].split('&')[0].split('=')[1] : 0;
    this.activeId =  location.hash.split('?')[1] ? location.hash.split('?')[1].split('&')[1].split('=')[1] : 0;
    this.getThemeHead()
    getNavTitle().then(res=>{
      res.data.forEach(item=>{
        item.title == '实验室服务项目' ? this.list = item.children : ''
      })
      for(let i in this.list){
        if(this.list[i].id == this.mobileId){
          this.mobileList.push(this.list[i])
        }
      }
       //默认拿到第一条数据显示处理
      if(this.cId){
        this.defaultShowId = this.cId;
          getProduct({defaultTypeId:this.defaultShowId}).then(res=>{
            let data = res.data.records[0]
            if(data){
                  this.headTitle = data.defaultTypeName;
                  this.contentHtmlPC = data.profiles
                  this.contentHtmlMobile = data.detailsPhone
            }
            this.loading = false
          })
      }else if(this.activeId){
        let childId = ""
        for(let i in this.list){
          if(this.list[i].id == this.activeId){
            childId = this.list[i].children[0].id
          }
        }
        this.defaultShowId = childId;
          getProduct({defaultTypeId:this.defaultShowId}).then(res=>{
            let data = res.data.records[0]
            if(data){
                  this.headTitle = data.defaultTypeName;
                  this.contentHtmlPC = data.profiles
                  this.contentHtmlMobile = data.detailsPhone
            }
            this.loading = false
          })
      }else{
        if(this.list.length){
          this.defaultShowId = this.list[0].children[0].id;
          this.headTitle = this.list[0].children[0].title;
          getProduct({defaultTypeId:this.defaultShowId}).then(res=>{
            let data = res.data.records[0]
            if(data){
                  this.contentHtmlPC = data.profiles
                  this.contentHtmlMobile = data.detailsPhone
            }
            this.loading = false
          })
        }else{
          this.headTitle="暂无数据";
          this.contentHtmlPC = "暂无数据";
          this.contentHtmlMobile = "暂无数据";
        }
      }
      
    })
  },
  methods:{
    init(e){
      this.headTitle = e.title
      this.loading = true
      this.contentHtmlMobile = '暂无信息'
      this.contentHtmlPC = '暂无信息'
      getProduct({defaultTypeId:e.id}).then(res=>{
         let data = res.data.records[0]
        if(data){
             this.contentHtmlPC = data.profiles
             this.contentHtmlMobile = data.detailsPhone
        }
        this.loading = false
      })
    },
    //主题返现
    getThemeHead(){
      getTheme({
        themeType : this.value
      }).then(res=>{
        this.headNavImg = res.data.records[0]
        res.data.records[0].picture = process.env.VUE_APP_WEB_URL + res.data.records[0].picture
      })
    },
    mobileShowData(data){
      if(data.length){
          this.defaultShowId = data[0].children[0].id;
          this.headTitle = data[0].children[0].title;
          getProduct({defaultTypeId:this.defaultShowId}).then(res=>{
            let data = res.data.records[0]
            if(data){
                  this.contentHtmlPC = data.profiles
                  this.contentHtmlMobile = data.detailsPhone
            }
            this.loading = false
          })
        }else{
          this.headTitle="暂无数据";
          this.contentHtmlPC = "暂无数据";
          this.contentHtmlMobile = "暂无数据";
        }
    }
  },
  computed: {
      // 获取路由传的ID
      cId(){
        return this.$route.query.cId ? this.$route.query.cId : ""
      },
      mobileId(){
        return this.$route.query.id ? this.$route.query.id : ""
      }
  },
  watch:{
    $route(){
      this.userId= this.$route.query.id
    },
    userId() {
      if(this.$IsPc()){
        this.mobileList = []
        for(let i in this.list){
          if(this.list[i].id == this.mobileId){
            this.mobileList.push(this.list[i])
          }
        }
        this.mobileShowData(this.mobileList)
      }else{
        this.$router.go(0)
      }
    }
  }
};
</script>

<style scoped>
.content {
  margin: 50px auto;
  width: 1190px;
}
.title {
  font-size: 20px;
  color: #053b7b;
  font-weight: 600;
}
.titleEn {
  color: #00397c;
  font-size: 18px;
}
.MobileRow{
  display: none;
}
@media screen and (max-width: 750px) {
  .content {
    display: none;
  }
  .MobileRow {
    margin: 20px 10px;
    display: block;
  }
  img{
    width: 100%;
    height: auto;
  }
}
</style>